"use strict";

module.exports = function (column) {
  if (!this.opts.filterable) return false;
  return typeof this.opts.filterable == 'boolean' && this.opts.filterable || this.opts.filterable.indexOf(column) > -1;
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/methods/filterable.js
// module id = 1609
// module chunks = 61